"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorageKeys = void 0;
var SessionStorageKeys;
(function (SessionStorageKeys) {
    SessionStorageKeys["AGLFunnelSQ"] = "AGLFunnelSQ";
    SessionStorageKeys["AccessToken"] = "AccessToken";
    SessionStorageKeys["BundleConfig"] = "bundleConfig";
    SessionStorageKeys["BundleSearchAddress"] = "bundleSearchAddress";
    SessionStorageKeys["CouponCode"] = "couponCode";
    SessionStorageKeys["CrossSellProductCategory"] = "crossSellProductCategory";
    SessionStorageKeys["CustomerProfile"] = "customerProfileService";
    SessionStorageKeys["FlowDetails"] = "flowDetails";
    SessionStorageKeys["PageHistory"] = "pageHistory";
    SessionStorageKeys["IsExistingMover"] = "isExistingMover";
    SessionStorageKeys["ModemProductDetailsSession"] = "modemProductDetails";
    SessionStorageKeys["ProductDetailsSession"] = "productDetails";
    SessionStorageKeys["SelectedMobileProductDetails"] = "selectedMobileProductDetails";
    SessionStorageKeys["SelectedNBNProductDetails"] = "selectedProductDetails";
    SessionStorageKeys["VoipProductDetailsSession"] = "voipProductDetails";
    SessionStorageKeys["accessTokenKey"] = "AccessToken";
    SessionStorageKeys["address"] = "address";
    SessionStorageKeys["bundleProducts"] = "bundleProductsResponse";
    SessionStorageKeys["carbonNeutralProductDetails"] = "carbonNeutralProductDetails";
    SessionStorageKeys["cart"] = "cart";
    SessionStorageKeys["cartId"] = "cartId";
    SessionStorageKeys["checkout"] = "checkout";
    SessionStorageKeys["confirmationData"] = "confirmationData";
    SessionStorageKeys["couponCode"] = "couponCode";
    SessionStorageKeys["energyConfiguration"] = "energy-configuration";
    SessionStorageKeys["internetConfiguration"] = "internet-configuration";
    SessionStorageKeys["lastValidateTime"] = "lastValidateTime";
    SessionStorageKeys["mobileConfiguration"] = "mobile-configuration";
    SessionStorageKeys["noOfCartItems"] = "noOfCartItems";
    SessionStorageKeys["productSearchResponse"] = "productSearchResponse";
    SessionStorageKeys["questionResponseenergy"] = "questionResponseenergy";
    SessionStorageKeys["questionResponsenbn"] = "questionResponsenbn";
    SessionStorageKeys["selectedProductDetails"] = "selectedProductDetails";
    SessionStorageKeys["existingNbnAccounts"] = "nbnExistingAccounts";
    SessionStorageKeys["partnerOfferDetails"] = "partnerOfferDetails";
    SessionStorageKeys["partnerOfferDetailsMobile"] = "partnerOfferDetailsMobile";
})(SessionStorageKeys = exports.SessionStorageKeys || (exports.SessionStorageKeys = {}));
//# sourceMappingURL=session-storage-keys.enum.js.map